import { HttpHeaders, HttpParams } from '@angular/common/http';
import { SortedPageInfo } from '../model/pagination/sorted-page-info';
import { selectConfig } from '../../modules/config/config.selector';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { ConfigModel } from '../../modules/config/config.model';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { Store } from '@ngrx/store';
import { ApplicationsState } from '../../modules/applications/applications.state';

export abstract class AbstractRestClient {
    accessToken: string;
    webApiKey: string;
    lang: string;

    initialized = false;

    protected constructor(
        public storeApp: Store<ApplicationsState>
    ) {
        this.storeApp.select(selectConfig)
            .combineLatest(this.storeApp.select(selectUrlParams))
            .filter(([config, urlParams]: ([ConfigModel, UrlParams])) => config && urlParams && !!config.webApiKey && !!urlParams.access_token)
            .subscribe(([config, urlParams]: ([ConfigModel, UrlParams])) => {
                this.accessToken = urlParams.access_token;
                this.webApiKey = config.webApiKey;
                this.lang = urlParams.lang;
                this.initialized = true;
                console.log('AbstractRestClient - read data');
            });
    }

    protected pagingHttpParams(pageInfo: Partial<SortedPageInfo>) {
        const result = new HttpParams()
            .append('page', '' + pageInfo.page)
            .append('size', '' + pageInfo.itemsPerPage);


        if (pageInfo.sort  &&  pageInfo.order) {
            return result
                .append('sort', pageInfo.sort.join(','))
                .append('order', pageInfo.order.join(','));
        }

        return result;
    }

    protected init(accessToken: string, webApiKey: string, lang: string) {
        this.accessToken = accessToken;
        this.webApiKey = webApiKey;
        this.lang = lang;

        this.initialized = true;
    }

    protected headers(): HttpHeaders {
        return new HttpHeaders()
            .set('Authorization', 'Bearer' + ' ' + this.accessToken)
            .append('WEB-API-Key', this.webApiKey)
            .append('Pragma', 'no-cache')
            .append('Accept-Language', this.lang);
    }

    protected checkInitialized() {
        if (!this.initialized) {
            console.log('AbstractRestClient - checkInitialized - not initialized');
            // throw new Error('REST Client has not been initialized yet.');
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/abstract-rest-client.service.ts